const STORAGE_KEY = 'ybb_main_auth'
export const SHARE_STORAGE_KEY = 'ybb_main_share_credential'
export const REQUEST_CREDENTIAL_STORAGE_KEY = 'ybb_main_request_credential'
export const SHARE_LOGOUT_STORAGE_KEY = 'ybb_main_logout'
export const SHOW_AMOUNT_STORAGE_KEY = 'ybb_main_amount'

const IS_SERVER = typeof window === 'undefined'

export const webStore = {
  async loadAuthAsync() {
    try {
      return Promise.resolve().then(function () {
        const auth = window.sessionStorage.getItem(STORAGE_KEY)
        return JSON.parse(auth as string)
      })
    } catch (e) {
      console.log(`get auth from store failed: ${e}`)
      return null
    }
  },
  async saveAuthAsync(value: object) {
    try {
      return Promise.resolve().then(function () {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value))
      })
    } catch (e) {
      console.log(`save auth in store failed: ${e}`)
    }
  },
  async saveAuthRawAsync(value: any) {
    try {
      return Promise.resolve().then(function () {
        sessionStorage.setItem(STORAGE_KEY, value)
      })
    } catch (e) {
      console.log(`save auth in store failed: ${e}`)
    }
  },
  async updateAuthAsync(value: object) {
    try {
      return Promise.resolve().then(function () {
        const auth = window.sessionStorage.getItem(STORAGE_KEY)
        sessionStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            ...JSON.parse(auth as string),
            ...value
          })
        )
      })
    } catch (e) {
      console.log(`merge auth in store failed: ${e}`)
    }
  },
  async clearAuthAsync() {
    try {
      if (!IS_SERVER) {
        sessionStorage.removeItem(STORAGE_KEY)
      }
    } catch (e) {
      console.log(`remove auth in store failed: ${e}`)
    }
  },
  async shareCredentialAsync() {
    const credential = sessionStorage.getItem(STORAGE_KEY)
    localStorage.setItem(SHARE_STORAGE_KEY, credential as string)
    localStorage.removeItem(SHARE_STORAGE_KEY)
  },
  async requestCredentialAsync() {
    localStorage.setItem(REQUEST_CREDENTIAL_STORAGE_KEY, Date.now().toString())
    localStorage.removeItem(REQUEST_CREDENTIAL_STORAGE_KEY)
  },
  async broadcastLogoutAsync() {
    localStorage.setItem(SHARE_LOGOUT_STORAGE_KEY, Date.now().toString())
    localStorage.removeItem(SHARE_LOGOUT_STORAGE_KEY)
  },
  async saveShowAmountAsync(value: object) {
    try {
      return Promise.resolve().then(function () {
        localStorage.setItem(SHOW_AMOUNT_STORAGE_KEY, JSON.stringify(value))
      })
    } catch (e) {
      console.log(`save showAmount in store failed: ${e}`)
    }
  },
  async getShowAmountAsync() {
    return Promise.resolve().then(function () {
      return localStorage.getItem(SHOW_AMOUNT_STORAGE_KEY)
    })
  },
  async getNotificationsStatus(id: string) {
    try {
      return Promise.resolve().then(function () {
        const obj = window.localStorage.getItem(`${STORAGE_KEY}/${id}`)
        return JSON.parse(obj as string)
      })
    } catch (e) {
      console.log(`get auth from store failed: ${e}`)
      return null
    }
  },
  async setNotificationsStatus(id: string, value: object) {
    try {
      return Promise.resolve().then(function () {
        localStorage.setItem(`${STORAGE_KEY}/${id}`, JSON.stringify(value))
      })
    } catch (e) {
      console.log(`save auth in store failed: ${e}`)
    }
  }
}
